import {AES, enc}from 'crypto-js';
import { fetchTokenPath, redirectURIPath } from '../../Services/config/apiGateway';

export const fetchRefreshToken = ({ clientId, scopes, clientSecret, code, state, tokenEndpoint, fetch = window.fetch }) => {
  const payload = {
    client_id: '8c19ff6c-0af1-48e9-b5ef-005a9a59e409',
    code,
    grant_type: 'authorization_code',
    code_verifier: state.encodedVerifier,
    redirect_uri: state.redirect_uri,
    scope:"8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access"
  };
  if (clientSecret) {
    payload.client_secret = clientSecret
  }
  const refreshToken =  sessionStorage.getItem("isAuthenticated")
  const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
const decryptedObject = decrypted.toString(enc.Utf8);
  //const refreshToken =  sessionStorage.getItem("isAuthenticated")
  const getRefreshToken = JSON.parse(decryptedObject)
  console.log(getRefreshToken)

  
 // console.log(getRefreshToken.refresh_token,"<<<<<<<<>>>>>>>")

 return fetch(`${fetchTokenPath}token?grant_type=refresh_token&client_id=8c19ff6c-0af1-48e9-b5ef-005a9a59e409&scope=8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access&redirect_uri=${redirectURIPath}&code_verifier=${state.encodedVerifier}&refresh_token=${getRefreshToken.tokenResponse.refresh_token}`, {
  // return fetch(`https://tpt-apim-cargo-dev.azure-api.net/ccLogin/v1/token?grant_type=refresh_token&client_id=8c19ff6c-0af1-48e9-b5ef-005a9a59e409&scope=8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}&refresh_token=${getRefreshToken.tokenResponse.refresh_token}`, {
    // return fetch(`https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/token?grant_type=refresh_token&client_id=8c19ff6c-0af1-48e9-b5ef-005a9a59e409&scope=8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}&refresh_token=${getRefreshToken.tokenResponse.refresh_token}`, {

    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    method: 'POST',
    //body: new window.URLSearchParams(payload)
  })
    .then(r => {
      if (!r.ok) {
        throw new Error(`Token response not ok, status is ${r.status}`);
      }
      return r.json();
    })
    .then(token => {
      const envryptedToken = AES.encrypt(JSON.stringify(token),'itsEncrypted').toString();
      sessionStorage.setItem("isAuthenticated",envryptedToken)
      const { expires_in } = token;
      if (expires_in && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        // add 'expires_at', with the given slack
        token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - (slackSeconds * 1000));
      }
      return token;
    })
    .catch(err => {
      console.error('ERR (fetch)', err);
      throw err;
    });
}
